import { useState } from "react";
import { useListContext } from "react-admin";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import DownloadIcon from "@mui/icons-material/Download";
import Cookies from "../Helpers/cookies";

const ClientExportButton = () => {
  const { filterValues } = useListContext();
  const [loading, setLoading] = useState(false);

  const handleExport = async () => {
    const apiUrl = process.env.REACT_APP_API_URL;
    const token = Cookies.getCookie("token");

    const { q, ...restFilters } = filterValues;
    const params = new URLSearchParams();
    if (q) params.set("_q", q);
    Object.entries(restFilters).forEach(([key, value]) => {
      if (value != null && value !== "") params.set(`filters[${key}]`, value);
    });

    const query = params.toString();
    const url = `${apiUrl}/client/export${query ? "?" + query : ""}`;

    setLoading(true);
    try {
      const response = await fetch(url, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (!response.ok) return;

      const blob = await response.blob();
      const downloadUrl = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = downloadUrl;
      a.download = "clients-export.csv";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(downloadUrl);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button
      onClick={handleExport}
      startIcon={loading ? <CircularProgress size={14} color="inherit" /> : <DownloadIcon />}
      disabled={loading}
      size="small"
    >
      {loading ? "Exporting…" : "Export"}
    </Button>
  );
};

export default ClientExportButton;
